const DEFAULT_LANG = process.env.VUE_APP_DEFAULT_LANG || 'de';
const LANG_STORAGE_KEY = 'lang';
const SUPPORTED_LANGS = Object.freeze(['zh', 'en', 'ja', 'kr', 'de', 'mn']);
const LANGUAGE_ALIASES = Object.freeze({
  jp: 'ja',
  ko: 'kr',
  kor: 'kr',
});
const DOCUMENT_LANGS = Object.freeze({
  zh: 'zh-CN',
  en: 'en',
  ja: 'ja',
  kr: 'ko',
  de: 'de',
  mn: 'mn',
});

function hasStorage() {
  try {
    return typeof window !== 'undefined' && window.localStorage;
  } catch (error) {
    return false;
  }
}

function normalizeLang(value) {
  if (!value || typeof value !== 'string') {
    return DEFAULT_LANG;
  }
  const normalized = value.trim().toLowerCase().replace(/_/g, '-');
  const primaryCode = normalized.split('-')[0];
  const language = LANGUAGE_ALIASES[normalized]
    || LANGUAGE_ALIASES[primaryCode]
    || primaryCode;

  return SUPPORTED_LANGS.includes(language) ? language : DEFAULT_LANG;
}

function syncDocumentLang(lang) {
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.lang = DOCUMENT_LANGS[lang] || lang;
  }
}

export function getCurrentLang() {
  if (!hasStorage()) {
    return DEFAULT_LANG;
  }
  const stored = window.localStorage.getItem(LANG_STORAGE_KEY);
  const normalized = normalizeLang(stored);
  if (!stored || stored !== normalized) {
    window.localStorage.setItem(LANG_STORAGE_KEY, normalized);
  }
  syncDocumentLang(normalized);
  return normalized;
}

export function setCurrentLang(lang) {
  const normalized = normalizeLang(lang);
  if (hasStorage()) {
    window.localStorage.setItem(LANG_STORAGE_KEY, normalized);
  }
  syncDocumentLang(normalized);
  return normalized;
}

export function syncLangWithBackend(httpClient, lang = getCurrentLang()) {
  if (!httpClient) {
    return Promise.resolve();
  }
  const normalized = normalizeLang(lang);
  return httpClient({
    method: 'get',
    url: 'replaceLang',
    data: { lang: normalized },
  }).catch((error) => {
    console.warn('syncLangWithBackend failed', error);
  });
}

export { DEFAULT_LANG, LANG_STORAGE_KEY, SUPPORTED_LANGS };
